export const FETCH_REPORTS = 'reporting-wrapper/fetch-reports';
export const RECEIVE_REPORS = 'reporting-wrapper/receive-reports';
export const CANCEL_FETCH_REPORTS = 'reporting-wrapper/cancel-fetch-reports';
